import { RouteComponent } from 'packages/smart-home-support/routes/models';
import { composePage, withFooterConfig, withHeaderConfig } from 'packages/smart-home-support/routes/utils';
import ProfilePage from './';
import { getUrl, getTabUrl } from './utils';
import { TabKey } from './models';
import { AddDevicePage, RefundSelectionPage, ViewDevicePage, RefundGuidePage } from './subpages';
import { PageId } from 'packages/smart-home-support/constants';
import { PageConfig } from 'packages/smart-home-support/models';

const withBackToTabButton = (backToTab?: TabKey) =>
  withHeaderConfig({ backTo: backToTab ? getTabUrl(backToTab) : getUrl() });

const composeProfilePage = (pageConfig: PageConfig, ...fns: Array<Function>) =>
  composePage(pageConfig, ...fns, withFooterConfig({ type: 'authenticated' }));

const routes: Array<RouteComponent> = [
  {
    Component: composeProfilePage({ pageId: PageId.Dashboard })(ProfilePage),
    route: { exact: true, path: getUrl() },
    title: 'Dashboard',
  },
  {
    Component: composeProfilePage({ pageId: PageId.Dashboard }, withBackToTabButton('devices'))(AddDevicePage),
    route: { exact: true, path: getUrl('add-device') },
    title: 'Dashboard | Add device',
  },
  {
    Component: composeProfilePage({ pageId: PageId.Dashboard }, withBackToTabButton('devices'))(ViewDevicePage),
    route: { exact: true, path: getUrl('view-device') },
    title: 'Dashboard | View device',
  },
  {
    Component: composeProfilePage(
      { pageId: PageId.RefundWarranties },
      withBackToTabButton('home')
    )(RefundSelectionPage),
    route: { exact: true, path: getUrl('warranty-selection') },
    title: 'Dashboard | Refund Selection',
  },
  {
    Component: composeProfilePage(
      { pageId: PageId.RefundGuide },
      withHeaderConfig({ backTo: getUrl('warranty-selection') })
    )(RefundGuidePage),
    route: { exact: true, path: getUrl('refund-guide') },
    title: 'Dashboard | Refund Guide',
  },
];

export default routes;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/routes.ts